// extracted by mini-css-extract-plugin
module.exports = {"icons":"YandexPaymentBlockIcons_icons_XL1Jx"};